import { ApiClient } from './client.js'
import { SFX_PSE_DOWNLOAD_LOG } from './resources.js'

const client = new ApiClient()

export default {
  list () {
    return client.get(`${SFX_PSE_DOWNLOAD_LOG}`)
  },

  listAll () {
    return client.getAll(`${SFX_PSE_DOWNLOAD_LOG}`)
  }
}
